module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074ba_banner_800x600.3a7d180f.png";